import { z } from 'zod';

import { ProcessingType } from './processing-type';

export type QueueProcessingPayload = z.infer<typeof queueProcessingPayloadSchema>;

export const queueProcessingPayloadSchema = z.object({
  overrides: z
    .object({
      heartbeatTimeout: z.number().optional(),
      isolated: z.boolean().optional(),
      pickupTimeout: z.number().optional(),
    })
    .optional(),
  pipeline: z.string().optional(),
  sessionId: z.uuid(),
  type: z.enum(ProcessingType),
});
